<template>
    <div class="login">
        <div class="login-form-block">
            <div class="login-form-logo">
                <logo />
                <div class="login-form-logo-text">
                    Конструктор корпоративного стандарта
                </div>
            </div>
            <div class="login-form">
                Авторизация
                <input type="text" v-model="email" placeholder="Логин" @click="isError = false" autocomplete="off" />
                <input type="password" v-model="password" placeholder="Пароль" @click="isError = false" autocomplete="off" />
                <Error v-show="isError" />
                <button @click="login()">ВОЙТИ</button>
            </div>
        </div>
    </div>
</template>

<style scoped src="../assets/style/login.css"></style>

<script>
import Logo from '@/assets/svg/logo.vue'
import Error from '@/components/login/error.vue'

export default {
    name: 'Login',
    components: {
        Logo, Error
    },
    data() {
        return {
            error_text: '',
            email: '',
            password: '',
            loader: this.$loading,
            isError: false

        }
    },
    methods: {
        login() {
            let loader = this.$loading.show()
            //this.loader.show();
            //let http_req = this.$axios;
            
            this.axios.post(process.env.VUE_APP_API_URL + '/api/login', {
                email: this.email,
                password: this.password
            })
            .then(response => {
              loader.hide();
              let is_admin = 0;//response.data.user.is_admin
              localStorage.setItem('token',response.data.access_token)
              localStorage.setItem('token_type',response.data.token_type)
              localStorage.setItem('admin', 1)
              localStorage.setItem('surname', response.data.surname)
              localStorage.setItem('name', response.data.name)
              localStorage.setItem('email', response.data.email)
              localStorage.setItem('user_id', response.data.id)
              localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
              this.isPreloaderShow = false;

              if (localStorage.getItem('token') != null){
                this.$emit('loggedIn')
              if(this.$route.params.nextUrl != null){
                this.$router.push(this.$route.params.nextUrl)
               }
               else {
                 if(is_admin== 1){
                    this.$router.push('admin')
               }
               else {
                this.$router.push('/')
               }
            }
          }
          })
          .catch(error => {
            //let loader = this.$loading
            loader.hide();
            this.error_text = error.response.status + ' ' + error.response.data.data;
            this.isError = true;
          });
            
        },
    }
}
</script>